/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export var isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/util/isArrayLike.js
// module id = 315
// module chunks = 0